import React from 'react';

import { Glossary, BoardGL } from 'common/utils/glossary';
import {
  Button,
  Message,
  Notes,
  Checkbox,
  LinkText,
  Spinner,
  Popup
} from 'common/components';
import { SubButtonType } from 'common/components/button';

interface BeforeCancelBoardProps {
  /** BeforeCancelBoardの表示有無 */
  isDisplay: boolean;
  /** 解約処理中か否か */
  isProcessing: boolean;
  /** グロッサリ */
  glossary: Glossary;
  /** "クローズボタン"の押下処理 */
  onClickClose: () => void;
  /** 解約する"の押下処理 */
  onClickCancelPurchase: () => void;
}

/**
 * 解約確認画面のPresentation Component
 */
export const BeforeIndividualCancelBoard: React.FC<BeforeCancelBoardProps> = ({
  isDisplay,
  isProcessing,
  glossary,
  onClickClose,
  onClickCancelPurchase
}) => {
  /**  チェック状態の定義と変更 */
  const [isChecked, setIsChecked] = React.useState<boolean>(false);

  /** チェックボックス変更時の処理 */
  const onChangeCheckBox = (event: any) => {
    setIsChecked(event.target.checked);
  };

  /** チェックボックスラベル押下時の処理 */
  const onClickCheckBoxLabel = () => {
    setIsChecked(!isChecked);
  };

  /** チェック状態によって購入ボタンのサブタイプを制御 */
  let subButtonType: SubButtonType = 'invalid';
  if (isChecked && !isProcessing) {
    subButtonType = 'highPriority';
  }

  /** 表示時にチェックボックスをチェックなしにする */
  React.useEffect(() => {
    setIsChecked(false);
  }, [isDisplay]);

  const onClickDeleteProcessing = () => {
    // 削除処理中はバックグラウンドをクリックしても何もしない
  };

  const _component =
    window.innerWidth > 639 || document.documentElement.clientWidth > 639 ? (
      <Popup
        className="beforeIndividualCancelBoard-popup"
        onClickBackground={
          isProcessing ? onClickDeleteProcessing : onClickClose
        }
        data-test="beforeIndividualCancelBoard-popup"
        visible={isDisplay}
      >
        <div
          className="beforeIndividualCancelBoard"
          data-test="beforeIndividualCancelBoard"
        >
          <Message
            type="message"
            data-test="beforeIndividualCancelBoard-message"
          >
            {glossary.glx(BoardGL.cancelPlan)}
          </Message>
          <Notes
            notes={[glossary.glx(BoardGL.cancelConfirmation)]}
            data-test={`beforeIndividualCancelBoard-notes`}
          />
          <div className="beforeIndividualCancelBoard-agreement">
            <Checkbox
              id="id_1"
              value="agreement"
              checked={isChecked}
              onChange={onChangeCheckBox}
              data-test="beforeIndividualCancelBoard-checkbox"
            />
            <LinkText
              type="checkBoxLabel"
              className="agreement-label"
              onClick={onClickCheckBoxLabel}
              data-test="beforeIndividualCancelBoard-agreementLabel"
            >
              {glossary.glx(BoardGL.acceptToCriteria)}
            </LinkText>
          </div>
          <div className="buttonFlex">
            <Button
              type="nextButton"
              subType={subButtonType}
              data-test="beforeIndividualCancelBoard-nextButton"
              onClick={onClickCancelPurchase}
            >
              {isProcessing ? (
                <Spinner type="button" width={22} height={22} color="#FFFFFF" />
              ) : (
                glossary.glx(BoardGL.cancelPlan)
              )}
            </Button>
            <Button
              className="cancelButton"
              type="toolButton"
              onClick={onClickClose}
              data-test="beforeIndividualCancelBoard-cancelButton"
            >
              {glossary.glx(BoardGL.cancel)}
            </Button>
          </div>
        </div>
      </Popup>
    ) : (
      <Popup
        className="beforeIndividualCancelBoard-popup"
        onClickBackground={
          isProcessing ? onClickDeleteProcessing : onClickClose
        }
        data-test="beforeIndividualCancelBoard-popup"
        visible={isDisplay}
      >
        <div
          className="beforeIndividualCancelBoard"
          data-test="beforeIndividualCancelBoard"
        >
          <Message
            type="message"
            data-test="beforeIndividualCancelBoard-message"
          >
            {glossary.glx(BoardGL.cancelPlan)}
          </Message>
          <Notes
            notes={[glossary.glx(BoardGL.cancelConfirmation)]}
            data-test={`beforeIndividualCancelBoard-notes`}
          />
          <div className="beforeIndividualCancelBoard-agreement">
            <Checkbox
              id="id_1"
              value="agreement"
              checked={isChecked}
              onChange={onChangeCheckBox}
              data-test="beforeIndividualCancelBoard-checkbox"
            />
            <LinkText
              type="checkBoxLabel"
              className="agreement-label"
              onClick={onClickCheckBoxLabel}
              data-test="beforeIndividualCancelBoard-agreementLabel"
            >
              {glossary.glx(BoardGL.acceptToCriteria)}
            </LinkText>
          </div>
          <Button
            type="nextButton"
            subType={subButtonType}
            data-test="beforeIndividualCancelBoard-nextButton"
            onClick={onClickCancelPurchase}
          >
            {isProcessing ? (
              <Spinner type="button" width={22} height={22} color="#FFFFFF" />
            ) : (
              glossary.glx(BoardGL.cancelPlan)
            )}
          </Button>
          <Button
            className="cancelButton"
            type="toolButton"
            onClick={onClickClose}
            data-test="beforeIndividualCancelBoard-cancelButton"
          >
            {glossary.glx(BoardGL.cancel)}
          </Button>
        </div>
      </Popup>
    );
  return isDisplay ? _component : null;
};
